/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useContext } from "react";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";

import "./ScaleBarWidget.scss";
import { MapContext } from "../../context/MapContext";

function ScaleBarWidget() {
  const [mapObject] = useContext(MapContext);

  useEffect(() => {
    if (mapObject?.view) {
      const scaler = new ScaleBar({
        view: mapObject?.view,
        //style: "ruler"
      });

      // adds the compass to the bottom-left corner of the MapView
      mapObject?.view.ui.add(scaler, "bottom-left");
    }
  }, [mapObject?.view]);

  return <></>;
}

export default ScaleBarWidget;
